import { AuthService } from "../services/authentication.service";
import { handleResponse } from '../helpers/handle-response';

// performs api calls by sending the required authentication headers
export function apiFetch(url: string, options: any) {
        
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': ''
    }

    // Setting Authorization header
    if (AuthService.loggedIn()) {
        headers['Authorization'] = 'Bearer ' + AuthService.getToken();
    }

    return fetch(url, {
        headers,
        ...options
    })
        .then(handleResponse)
}